import { usePageNumberFromUrl, usePerPageValueFromUrl, useSortValueFromUrl } from 'idsk-react-components';

import { SortDirectionEnum } from 'vestniky-frontend-ts-axios';
import {
  defaultSortPrispevkyVestnika,
  sortValuesPrispevkyVestnika,
} from '../../../constants/SortConstants';
import { ClientStatus } from '../../../model/types/ClientStatus';
import PrispevokVestnikaListPage from '../../../model/PrispevokVestnikaListPage';
import PrispevokVestnikaListFilter from '../../../model/PrispevokVestnikaListFilter';
import { defaultPerPageValue, perPageDataArray } from '../../../constants/PaginationPerPageConstants';
import { useClientFetch } from '../../../context/ClientStatusContext';
import { fetchPrispevokVestnikaFilteredPage } from '../../../client/prispevokVestnikaListClient';

interface ReturnType {
  prispevokVestnikaPage: PrispevokVestnikaListPage;
  requestStatus: ClientStatus;
}

const getSort = (sortValue): string => {
  if (!sortValuesPrispevkyVestnika.includes(sortValue)) {
    return defaultSortPrispevkyVestnika;
  }
  return sortValue;
};

export default (filter: PrispevokVestnikaListFilter): ReturnType => {
  const { page } = usePageNumberFromUrl('page');
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const { sort } = useSortValueFromUrl();
  const {
    data: prispevokVestnikaPage,
    status: requestStatus,
  } = useClientFetch(
    fetchPrispevokVestnikaFilteredPage,
    [filter, page, perPageValue, getSort(sort[0]),
      sort[1] === 'asc' ? SortDirectionEnum.Asc : SortDirectionEnum.Desc],
    [JSON.stringify(filter), page, perPageValue, sort[0], sort[1]],
  );

  return {
    prispevokVestnikaPage,
    requestStatus,
  };
};
